import React from 'react'
import { HashRouter as Router, Route, Routes } from 'react-router-dom'
import Home from './Home'
import PartOrders from './PartOrders'
import PartOrderForm from './PartOrderForm'

const RoutesContainer: React.FC = (props) => {
  return (
    <Router>
        {props.children}
        <Routes>
            <Route path='/' element={<Home/>}></Route>
            <Route path='/part-orders' element={<PartOrders/>}></Route>
            <Route path='/part-orders/create' element={<PartOrderForm/>}></Route>
            <Route path='/part-orders/:id/edit' element={<PartOrderForm/>}></Route>
        </Routes>
    </Router>
  )
}

export default RoutesContainer
